module.exports = __webpack_public_path__ + "img/s-business.558bf6a1.svg";